import {CalculUtils} from '@hublot-io/core-utils'
import moment from 'moment'
import Vue from 'vue'


export const initFilter = () => {
  const toNumber = (value, fixed) => {
    if (isNaN(value) || value === Infinity || value === -Infinity) {
      return '-'
    }
    return CalculUtils.round2(value).toFixed(fixed)
  }
  
  Vue.filter('pourcentage', value => {
    if (toNumber(value, 2).length > 6) {
      return `${toNumber(value, 0)} %`
    }
    return `${toNumber(value, 2)} %`
  })
  
  Vue.filter('frenchDateFormat', value => moment(value).format('Do MMMM YYYY'))
  
  Vue.filter('roundedPourcentage', value => `${toNumber(value, 0)} %`)
  Vue.filter('roundedPourcentage2', value => `${toNumber(value, 2)} %`)
  
  
  Vue.filter('roundedEuros', value => {
    if (isNaN(value) || value === Infinity || value === -Infinity) {
      return '0 €'
    }
    return `${Math.round(parseFloat(value)).toLocaleString()} €`
  })
  
  Vue.filter('formatHour', value => moment(value).format('HH[h]mm'))
  Vue.filter('euros', value => {
    if (isNaN(value) || value === Infinity || value === -Infinity) {
      return '0 €'
    } if (value.length > 6 && value.includes('.')) {
      return `${Math.round(parseFloat(value))} €`
    }
    return `${CalculUtils.round2(parseFloat(value)).toLocaleString(undefined, {minimumFractionDigits: 2})} €`
  })
  
  Vue.filter('objectif', value => {
    if (isNaN(value)) {
      return '0 €'
    }
    const result = CalculUtils.round2(parseFloat(value))
    if (result < 0) {
      return `+ ${Math.abs(result).toLocaleString(undefined, {minimumFractionDigits: 2})} €`
    }
    return `${result.toLocaleString(undefined, {minimumFractionDigits: 2})} €`
  })
}